import type { LogExitCategory } from "src/analytics/analyticsEventTypes";
import { logExit } from "src/analytics/exits/logExit";
import type {
  PartnerPageExitCategory,
  Trigger,
  View,
} from "src/analytics/exits/generateExitPoint/generateExitPoint";
import useSearch from "../../utils/hooks/useSearch";
import type { Mode } from "../../utils/types/mode";
import { useApiConfig } from "../../api/ApiConfigProvider";

// Creates and returns a callback that, when invoked, logs exits to the Rome2Rio
// backend.
export function useLogExitCallback(
  exitKind: LogExitCategory,
  view: View,
  trigger: Trigger,
  transitMode?: Mode,
  partnerPage?: PartnerPageExitCategory,
) {
  const { searchResponse, origin, destination } = useSearch();
  const requestId = searchResponse?.request.requestId;
  const config = useApiConfig();

  return (
    destinationUrl: string,
    provider?: string,
    agencyIds?: string[],
    overrideTrigger?: Trigger,
    navigationEventId?: string,
  ) => {
    logExit(config, {
      category: exitKind,
      provider: provider,
      agencyIds: agencyIds,
      originCanonical: origin?.canonicalName,
      destinationCanonical: destination?.canonicalName,
      destinationUrl,
      requestId,
      exitPoint: {
        view,
        trigger: overrideTrigger ?? trigger,
        transitMode,
      },
      partnerPage: partnerPage ?? "NotSpecified",
      navigationEventId,
    });
  };
}
